export const FOCUSED_FRAMES_NUMBER = 30;
export type FocusedAreaRange = [number, number];

export function getFocusedRange(
  frameNumber: number,
  maxFrameNumber: number,
): FocusedAreaRange {
  if (FOCUSED_FRAMES_NUMBER >= maxFrameNumber) {
    return [0, maxFrameNumber];
  }
  const halfLength = Math.floor(FOCUSED_FRAMES_NUMBER / 2);
  if (frameNumber <= halfLength) {
    return [0, FOCUSED_FRAMES_NUMBER];
  }
  if (frameNumber >= maxFrameNumber - halfLength) {
    return [maxFrameNumber - FOCUSED_FRAMES_NUMBER, maxFrameNumber];
  }

  return [frameNumber - halfLength, frameNumber + halfLength];
}

export function getNonFocusedSections(
  frameNumbers: FocusedAreaRange | undefined,
  maxFrameNumber: number,
) {
  if (!frameNumbers) {
    return undefined;
  }

  const leftSection = `${(frameNumbers[0] / maxFrameNumber) * 100}%`;
  // Removing 10px to take into consideration the width of both brackets.
  const minFocusArea = Math.min(FOCUSED_FRAMES_NUMBER / maxFrameNumber, 1.0);
  const focusArea = `max(calc(${minFocusArea * 100}% - 10px), 0px)`;

  const rightSection = `${(1 - frameNumbers[1] / maxFrameNumber) * 100}%`;
  return [leftSection, focusArea, rightSection];
}
